import { Component, OnInit } from '@angular/core';
import { User } from '../_models/index';
// import { UserService } from '../_services/index';

@Component({
  selector: 'app-staff',
  templateUrl: './staff.component.html',
  styleUrls: ['./staff.component.css']
})
export class StaffComponent implements OnInit {

  currentUser: User;
  users: User[] = [];

  constructor() {
    //this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
}

  ngOnInit() {
  }

}
